import React, { useEffect, useRef, useState } from "react";
import Button from "./Common/Button";
import useNetworkServices from "../Networking/baseAPIManager";
import { FaFileUpload } from "react-icons/fa";
import Loader from "./Common/Loader";
import { Toastify } from "./Common/Toastify";

function IndustryManagement() {
  let BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG;
  const ImageInputRef = useRef(null);
  const [imageName, setImageName] = useState("No file chosen");
  const [industryData, setIndustryData] = useState({ title: "", image: "" });
  const [industryList, setIndustryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [type, setType] = useState("info");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [randomColor] = useState([
    "#FBC0C6",
    "#FCE263",
    "#A5E4FB",
    "#FF9696",
    "#ABEAA5",
  ]);

  const { CreateCategory, GetAllCategory } = useNetworkServices();

  const onHandelChange = (name, value) => {
    setIndustryData({ ...industryData, [name]: value });
  };

  useEffect(() => {
    getIndustryList();
  }, []);

  const getIndustryList = async () => {
    setLoading(true);
    try {
      const response = await GetAllCategory();
      setIndustryList(response.data.data);
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageName(file.name);
      setIndustryData({ ...industryData, image: file });
    } else {
      setImageName("No file chosen");
    }
  };

  const onFormSubmit = async (e) => {
    e.preventDefault();

    const formErrors = {};

    if (!industryData.title) {
      formErrors.title = "Industry Name is Required";
    }
    if (!industryData.image) {
      formErrors.image = "Industry Image is Required";
    }

    const formData = new FormData();

    formData.append("title", industryData.title);
    formData.append("image", industryData.image);
    setDisable(true);
    try {
      const response = await CreateCategory(formData);
      if (response.status === 201) {
        getIndustryList();
        setIndustryData({ title: "", image: "" });
        setImageName("");
        setType("success");
        setMessage(response?.data?.message || "Industry created successfully");
        setDisable(false);
        setShow(true);
      }
    } catch (error) {
      setType("error");
      setMessage(error?.response?.data?.message || "Industry creation failed");
      setDisable(false);
      setShow(true);
      console.error("Error adding industry:", error);
    }
  };

  const handleButtonClick = () => {
    ImageInputRef.current.click();
  };

  return (
    <div id="main" className="p-4">
      <Toastify type={type} message={message} show={show} setShow={setShow} />
      <h1 className="font-bold text-2xl text-slate-900 pb-5">
        <span>Industry Management</span>
      </h1>
      <div className="flex flex-wrap gap-6 items-end">
        {/* Industry Name Input */}
        <div className="flex-1 w-full md:w-1/2">
          <div>
            <label className="block mb-2 text-base font-bold text-gray-900">
              Add Industry Name
            </label>
          </div>

          <input
            type="text"
            name="title"
            placeholder="Food"
            className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            onChange={(e) => onHandelChange(e.target.name, e.target.value)}
            value={industryData.title}
          />
        </div>

        {/* Industry Image Input */}
        <div className="flex-1 w-full md:w-1/2">
          <label className="block mb-2 text-base font-bold text-gray-900">
            Add Industry Image
          </label>
          <div className="flex items-center justify-between border border-gray-300 rounded-lg p-2">
            <input
              ref={ImageInputRef}
              type="file"
              name="industryImage"
              accept="image/*"
              className="hidden"
              onChange={handleFileChange}
            />
            <span className="flex-1 text-gray-600 truncate">
              {imageName ? imageName : industryData.image}
            </span>
            <Button
              type="button"
              className="ml-2 bg-gray-200 hover:bg-gray-300 rounded-lg p-1"
              onClick={handleButtonClick}
              text={<FaFileUpload className="w-full h-full" />}
            />
          </div>
        </div>

        {/* Save Button */}
        <div className="w-full md:w-auto">
          <button
            type="button"
            disabled={disable}
            className={`w-full md:w-auto bg-red-500 text-white font-bold py-2 px-6 rounded-lg hover:bg-red-600 focus:ring-2 focus:ring-red-300 transition ${
              disable ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={onFormSubmit}
          >
            {disable ? "Saving" : "Save"}
          </button>
        </div>
      </div>

      {/* Industry List */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {industryList.map((industry, index) => (
          <div
            key={index}
            className="flex items-center p-4 rounded-lg shadow-lg"
            style={{
              backgroundColor: randomColor[index % randomColor.length],
              height: "120px",
            }}
          >
            <div className="flex-1">
              <p className="text-xl font-semibold text-gray-800">
                {industry.title}
              </p>
            </div>
            <div className="w-24 h-24 flex-shrink-0">
              <img
                src={`${BASE_URL_IMG}/${industry.image}`}
                alt={industry.title}
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        ))}
      </div>

      {loading && <Loader />}
    </div>
  );
}

export default IndustryManagement;
